<template>
  <nav class="navbar">
    <div class="navbar-logo">
      <img class="logo" src="@/assets/logo.png" alt="QuickMatrixTool Logo" />
      <p>Quick Matrix Tool</p>
    </div>

    <button
      class="navbar-toggle"
      type="button"
      :aria-expanded="menuOpen ? 'true' : 'false'"
      aria-controls="navbar-links"
      aria-label="切换导航菜单"
      @click="menuOpen = !menuOpen"
    >
      <span class="navbar-toggle-bar"></span>
      <span class="navbar-toggle-bar"></span>
      <span class="navbar-toggle-bar"></span>
    </button>

    <ul id="navbar-links" class="navbar-links" :class="{ open: menuOpen }">
      <li><a href="#" @click.prevent="onDownload">下载</a></li>
      <li><a href="#" @click.prevent="scrollToCard('card2')">功能介绍</a></li>
      <li><a href="#" @click.prevent="scrollToCard('card4')">效果展示</a></li>
      <li>
        <a
          href="https://space.bilibili.com/3546787388328447"
          target="_blank"
          rel="noopener noreferrer"
          @click="menuOpen = false"
        >B站反馈(专集视频待更新)</a>
      </li>
      <li>
        <a
          href="https://store.steampowered.com/app/1995300/QuickMatrix"
          target="_blank"
          rel="noopener noreferrer"
          @click="menuOpen = false"
        >Steam版(附加专属功能)</a>
      </li>
      <li>
        <router-link to="/privacy-policy" @click="menuOpen = false">隐私协议</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    onDownload() {
      this.menuOpen = false;
      this.$downloadClient();
    },
    scrollToCard(id) {
      this.menuOpen = false;
      const el = document.getElementById(id);
      if (!el) return;
      const container = document.querySelector('.content');
      if (!container) return;

      // 用 getBoundingClientRect 精确计算目标在容器内的滚动偏移
      const containerRect = container.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      const targetTop = container.scrollTop + (elRect.top - containerRect.top);

      container.style.scrollSnapType = 'none';
      container.scrollTo({ top: targetTop, behavior: 'smooth' });

      const restore = () => {
        container.style.scrollSnapType = '';
        container.removeEventListener('scrollend', restore);
      };
      container.addEventListener('scrollend', restore);
      setTimeout(restore, 1200);
    }
  }
}
</script>

<style scoped>
.navbar {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background-color: #151910;
  color: #fff;
  height: 60px;
  z-index: 1000;
}

.navbar-logo {
  display: flex;
  padding: 0px;
  margin: 0px;
  height: 60px;
}

.logo {
  height: 36px;
  padding: 12px 12px 12px 24px;
  color: #ccc;
}

.navbar-logo p {
  color: #ccc;
  font-size: 24px;
  font-family: "Times New Roman", Times, serif;
  height: 36px;
  padding: 16px 0px 12px 0px;
  margin: 0px;
}

.navbar-links {
  list-style: none;
  display: flex;
  gap: 15px;
  margin: 0 12% 0 0;
  padding: 0;
}

.navbar-links li a {
  text-decoration: none;
  font-size: 18px;
  color: #ccc;
  margin: 0;
}

.navbar-links li a:hover {
  color: #fff;
}

/* 汉堡按钮:默认隐藏,移动端显示 */
.navbar-toggle {
  display: none;
  width: 44px;
  height: 44px;
  margin-right: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.navbar-toggle-bar {
  width: 24px;
  height: 2px;
  background: #ccc;
  border-radius: 1px;
}

@media (max-width: 768px) {
  .navbar {
    height: 56px;
    flex-wrap: wrap;
  }

  .logo {
    height: 28px;
    padding: 14px 8px 14px 16px;
  }

  .navbar-logo p {
    font-size: 18px;
    padding: 18px 0 12px 0;
    height: 28px;
  }

  .navbar-toggle {
    display: flex;
  }

  .navbar-links {
    display: none;
    flex-direction: column;
    width: 100%;
    margin: 0;
    padding: 8px 0;
    background-color: #1c2117;
    gap: 0;
    order: 3;
  }

  .navbar-links.open {
    display: flex;
  }

  .navbar-links li {
    width: 100%;
    text-align: center;
    border-top: 1px solid #2a2f24;
  }

  .navbar-links li a {
    display: block;
    padding: 12px 16px;
    font-size: 15px;
  }
}
</style>
